import { useEffect, useState } from 'react';

import { STORAGE_KEY } from '../utils/constants';

export const useViewedNotifications = () => {
	const [viewedNotificationIds, setViewedNotificationIds] = useState<
		Set<string>
	>(new Set());

	useEffect(() => {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored) {
			try {
				const ids = JSON.parse(stored) as string[];
				setViewedNotificationIds(new Set(ids));
			} catch {
				// Если невалидный JSON, игнорируем
			}
		}
	}, []);

	const markAsViewed = (notificationId: string) => {
		const newViewedIds = new Set(viewedNotificationIds);
		newViewedIds.add(notificationId);
		setViewedNotificationIds(newViewedIds);
		localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(newViewedIds)));
	};

	const isNotificationViewed = (notificationId: string | null) => {
		if (!notificationId) return false;
		return viewedNotificationIds.has(notificationId);
	};

	return {
		viewedNotificationIds,
		markAsViewed,
		isNotificationViewed,
	};
};
